<template>
  <footer class="site-footer">
    <div class="footer-content">
      <div class="footer-section">
        <h3>&nbsp;</h3>
        <p>
          {{ $t("footer.aboutUsDesc") }}
        </p>
      </div>

      <div class="footer-section">
        <h3>{{ $t("footer.contactInfo") }}</h3>
        <p>{{ $t("footer.phone") }}：{{ $t("contact.phone1") }}</p>
        <p>{{ $t("footer.email") }}：{{ $t("contact.email") }}</p>
        <p style="display: flex">
          {{ $t("footer.address") }}：
          <span style="display: inline-block; flex: 1">
            <span class="address-item" style="margin-top: 3px;">{{ $t("contact.address") }}</span>
            <span class="address-item">{{
              $t("contact.addressZhongshan")
            }}</span>
          </span>
        </p>
      </div>

      <div class="footer-section">
        <!-- <h3>{{ $t('footer.followUs') }}</h3> -->
        <h3>&nbsp;</h3>
        <div class="social-links">
          <el-button type="text" @click="openWhatsApp">
            <img src="@/assets/whatsapp.svg" alt="" />
            <span class="social-text">WhatsApp</span>
          </el-button>
          <el-button type="text" @click="openWeChat">
            <img src="@/assets/wechat-fill.svg" alt="" />
            <span class="social-text">WeChat</span>
          </el-button>
          <el-button type="text" @click="openTelegram">
            <img src="@/assets/Telegram.svg" alt="" />
            <span class="social-text">Telegram</span>
          </el-button>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <p>
        © 2025 {{ $t("footer.companyName") }}.
        {{ $t("footer.allRightsReserved") }}.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
  data() {
    return {
      imageUrl: require("@/assets/wechat-qr.jpg"),
      imageUrl2: require("@/assets/telegram-qr.jpg"),
      imageUrl3: require("@/assets/whatsapp-qr.jpg"),
      // 移动端直接跳转的链接（占位符，请替换为真实链接）
      mobileLinks: {
        whatsapp: "https://wa.me/message/D6GKHEXM3HJXF1",
        telegram: "https://t.me/KamZiHK",
      },
    };
  },
  methods: {
    /**
     * @description 判断是否为移动端（基于 User-Agent）
     * @returns {boolean}
     */
    isMobile() {
      if (typeof navigator === "undefined") return false;
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    /**
     * @description 显示WhatsApp二维码或移动端直接跳转
     */
    openWhatsApp() {
      if (this.isMobile()) {
        window.location.href = this.mobileLinks.whatsapp;
        return;
      }
      this.$alert(
        `<div style="text-align: center;"><div style="width: 200px; height: 200px; background-color: #f5f5f5; border: 2px dashed #ddd; border-radius: 8px; display: flex; align-items: center; justify-content: center; margin: 0 auto;">
          <img style="height: 199px;width: 200px;" src="${this.imageUrl3}" alt="" />
        </div></div>`,
        this.$t("footer.whatsappQr"),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t("common.confirm"),
          customClass: "whatsapp-qr-dialog",
          beforeClose: (action, instance, done) => {
            done();
          },
        }
      ).catch(() => {
        // 忽略关闭时的错误
      });
    },
    /**
     * @description 显示微信二维码或移动端直接跳转
     */
    openWeChat() {
      this.$alert(
        `<div style="text-align: center;"><div style="width: 200px; height: 200px; background-color: #f5f5f5; border: 2px dashed #ddd; border-radius: 8px; display: flex; align-items: center; justify-content: center; margin: 0 auto;">
           <img style="height: 199px;width: 200px;" src="${this.imageUrl}" alt="" /></div></div>`,
        this.$t("footer.wechatQr"),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t("common.confirm"),
          customClass: "wechat-qr-dialog",
          beforeClose: (action, instance, done) => {
            done();
          },
        }
      ).catch(() => {
        // 忽略关闭时的错误
      });
    },
    /**
     * @description 显示Telegram二维码或移动端直接跳转
     */
    openTelegram() {
      if (this.isMobile()) {
        window.location.href = this.mobileLinks.telegram;
        return;
      }
      this.$alert(
        `<div style="text-align: center;"><div style="width: 200px; height: 200px; background-color: #f5f5f5; border: 2px dashed #ddd; border-radius: 8px; display: flex; align-items: center; justify-content: center; margin: 0 auto;">
           <img style="height: 199px;width: 200px;" src="${this.imageUrl2}" alt="" /></div></div>`,
        this.$t("footer.telegramQr"),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t("common.confirm"),
          customClass: "telegram-qr-dialog",
          beforeClose: (action, instance, done) => {
            done();
          },
        }
      ).catch(() => {
        // 忽略关闭时的错误
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.site-footer {
  background-color: #333;
  color: #fff;
  padding: 40px 0 20px;

  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding: 0;

    .footer-section {
      flex: 1;
      margin: 0 10px;

      h3 {
        color: #ff6b00;
        margin-bottom: 20px;
        font-size: 18px;
      }

      p {
        margin: 10px 0;
        line-height: 1.6;
      }

      .address-item {
        margin: 5px 0;
        font-size: 14px;
        line-height: 1.5;
        display: inline-block;
      }

      .social-links {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 15px;

        .el-button {
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 8px 12px;
          border-radius: 6px;
          transition: all 0.3s ease;
          margin-right: 0;
          min-width: 80px;

          &:hover {
            color: #ff6b00;
            background-color: rgba(255, 255, 255, 0.1);
            transform: translateY(-2px);
          }

          i {
            font-size: 20px;
            margin-right: 8px;
          }

          .social-text {
            font-size: 14px;
            font-weight: 500;
            text-align: center;
          }
        }
      }
    }
  }

  .footer-bottom {
    text-align: center;
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);

    p {
      margin: 0;
      font-size: 14px;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 32px 16px 16px;

    .footer-content {
      display: block;
      padding: 0;

      .footer-section {
        margin: 0 0 28px;

        h3 {
          margin-bottom: 12px;
        }

        .social-links {
          gap: 8px;
        }
      }
    }

    .footer-bottom {
      margin-top: 24px;

      p {
        line-height: 1.6;
      }
    }
  }
}

// 微信二维码弹窗样式
:global(.wechat-qr-dialog) {
  .el-message-box__content {
    padding: 30px;
  }

  .el-message-box__header {
    background-color: #fff;
    color: #333;

    .el-message-box__title {
      color: #333;
      font-weight: bold;
    }
  }

  .el-message-box__body {
    text-align: center;

    img {
      border: 2px solid #f0f0f0;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  }

  .el-button--primary {
    background-color: #ff6b00;
    border-color: #ff6b00;

    &:hover {
      background-color: #ff8533;
      border-color: #ff8533;
    }
  }
}

// WhatsApp二维码弹窗样式
:global(.whatsapp-qr-dialog) {
  .el-message-box__content {
    padding: 30px;
  }

  .el-message-box__header {
    background-color: #fff;
    color: #333;

    .el-message-box__title {
      color: #333;
      font-weight: bold;
    }
  }

  .el-message-box__body {
    text-align: center;

    img {
      border: 2px solid #f0f0f0;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  }

  .el-button--primary {
    background-color: #ff6b00;
    border-color: #ff6b00;

    &:hover {
      background-color: #ff8533;
      border-color: #ff8533;
    }
  }
}

// Telegram二维码弹窗样式
:global(.telegram-qr-dialog) {
  .el-message-box__content {
    padding: 30px;
  }

  .el-message-box__header {
    background-color: #fff;
    color: #333;

    .el-message-box__title {
      color: #333;
      font-weight: bold;
    }
  }

  .el-message-box__body {
    text-align: center;

    img {
      border: 2px solid #f0f0f0;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  }

  .el-button--primary {
    background-color: #ff6b00;
    border-color: #ff6b00;

    &:hover {
      background-color: #ff8533;
      border-color: #ff8533;
    }
  }
}
</style>
